class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();

    setTimeout(function() {
    let cPageUrl = $('#cart-icon-bubble').attr('href');
    // $('#cart_form').load(cPageUrl+"?section_id=template--19861234417976__cart&view=flash-incentives&t="+jQuery.now()+" #cart_form");
    // $('#cart_sign').click();
    $.ajax({
     url: cPageUrl,
     method: 'GET',
     dataType : 'html',
     data : { section_id: "template--15703669473373__main-cart-items", view:"flash-incentives", t:jQuery.now() },
     success: function(response) {
       // console.log('response',response)
        var resp = $(response).find('#main-cart-items');
        var ourhtml = resp[0].innerHTML;
         $('.main-cart-details #main-cart-items').html(ourhtml);
         $('.main-cart-details cart-items').removeClass('is-empty');
     }
    });
    $.ajax({
       url: cPageUrl,
       method: 'GET',
       dataType : 'html',
       data : { section_id: "template--15703669473373__main-cart-footer", view:"flash-incentives", t:jQuery.now() },
       success: function(response) {
         // console.log('response',response)
          var resp = $(response).find('#main-cart-footer').html();
         $('.main-cart-details #main-cart-footer').removeClass('is-empty');
          
         // console.log('ourhtml', resp)
           $('.main-cart-details #main-cart-footer').html(resp);
       }
      });
}, 1000);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      },
      {
        id: 'cart-icon-bubble-desktop'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
